/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint no-new: 0 */
define(function (require) {
  var $ = require("jquery");
  var modalWindow = require("site/mobile/modal-window");
  var siteTypeSwitch = require("site/common/site-type-switch");
  var addPageNavigationUpdateCanonicalUrl = require("site/mobile/canonical").addPageNavigationUpdateCanonicalUrl;

  window.pagesPositioning = {};
  window.goingBack = false;
  var eventAdded = false;

  function scrollToTop () {
    // Scroll window to top, so we show the Apple smart banner
    window.oldScroll = window.scrollTo;
    window.scrollTo = function () {return false;};
  }

  function attachEvents () {
    addPageNavigationUpdateCanonicalUrl();

    $(document).on("create", "[data-role=page]", function () {
      modalWindow.hide();

      if (!eventAdded) {
        $(window).on("popstate", function (evt) {
          window.goingBack = false;

          if (evt.historyState) {
            window.goingBack = true;
          }

          $(window).on("popstate");
        });

        eventAdded = true;
      }
    });

    $(document).on("pagebeforehide", "[data-role=page]", function () {
      var topValue;

      if (!window.goingBack) {
        topValue = $("body").scrollTop();
      } else {
        topValue = 0;
        window.goingBack = false;
      }

      window.pagesPositioning[$(this).attr("id")] = topValue;
    });

    $(document).on("pageshow", "[data-role=page]", function () {
      if (window.pagesPositioning[$(this).attr("id")] === undefined) {
        window.pagesPositioning[$(this).attr("id")] = 0;
      }

      if (window.pagesPositioning[$(this).attr("id")] !== undefined) {
        if ($.scrollTo) {
          $("body").scrollTo(window.pagesPositioning[$(this).attr("id")]);
        }
      }
    });
  }

  function removeRedirectCookie () {
    $(document).on("pagehide", "[data-role=page]", function () {
      siteTypeSwitch.clearMobileBrowseUriCookie();
    });
  }

  function showModalWindowBeforeShowingNewPage () {
    $(document).on("pagebeforeshow", "[data-role=page]", function () {
      if (!$(this).data("noLoadingIndicator")) {
        modalWindow.show();
      }
    });
  }

  function filterInputBlurOnEnterKey () {
    $(document).on("keypress", ".ui-listview-filter input", function (event) {
      if (event.charCode === 13) {
        $(this).blur();
      }
    });
  }

  function initializeMobile () {
    scrollToTop();
    showModalWindowBeforeShowingNewPage();
    filterInputBlurOnEnterKey();
    removeRedirectCookie();
    attachEvents();
  }

  return {
    initialize: initializeMobile
  };
});

}.call(window));